export enum EAppRoute {
  Admin = 'admin',
  Dashboard = 'dashboard',
  Development = 'development',
  Icons = 'icons',
  NotFound = '404',
  NoAccess = 'no-access',
  AdminNoAccess = 'admin-no-access',
}
